import { formatMetric, sortProducts } from "@/lib/catalog-format";
import { REVIEWED_AT } from "@/lib/catalog-date";
import type { CatalogProduct, Metric } from "@/lib/comparison-catalog";
import { t, type Locale } from "@/lib/i18n";
import { RankBars } from "@/components/charts/rank-bars";
import { bestValue, chartCopy, exactValue, sourceFor } from "@/components/charts/chart-utils";

/** One horizontal bar per product on a zero-based scale, best value in data green; the value is
 * always printed next to the bar and hover/focus shows the exact figure, its source and date. */
export function MetricBars({ rows, metric, locale = "es", reviewedAt = REVIEWED_AT, compact = false }: { rows: CatalogProduct[]; metric: Metric; locale?: Locale; reviewedAt?: string; compact?: boolean }) {
  const copy = t(locale).catalog;
  const charts = chartCopy[locale];
  const known = sortProducts(rows.filter(p => p.values[metric.key] != null), metric.key, metric.direction);
  const best = bestValue(known.map(p => p.values[metric.key]), metric);
  return <div className="vc-bars">
    {known.length > 0 && <RankBars label={copy.barsLabel(metric.label)} best={best} bestLabel={charts.best} compact={compact} formatTick={value => formatMetric(value, metric, locale)}
      rows={known.map(p => {
        const value = p.values[metric.key]!;
        const source = sourceFor(p, metric);
        return { id: p.id, label: p.name, value, display: formatMetric(value, metric, locale), color: p.color, tip: [p.name, exactValue(value, metric, locale), ...(source ? [`${charts.source}: ${source.label}`] : []), charts.reviewed(p.reviewedAt ?? reviewedAt)] };
      })} />}
    {!known.length && <p className="vc-empty">{copy.barsEmpty}</p>}
    {known.length !== rows.length && <small className="vc-foot-note">{copy.barsMissing(rows.length - known.length)}</small>}
  </div>;
}
